export default "__VITE_ASSET__C4YVc21d__"